// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
export const IS_MODERN_SSR = false;
